/* ========================================
   EXPERIMENTAL PAGE - FAQ accordion
   Single-open accordion, matches Lovable faq.tsx behavior
   ======================================== */
(function () {
  function init() {
    var scope = document.querySelector('.exp-body') || document;
    var items = Array.prototype.slice.call(scope.querySelectorAll('[data-exp-faq-item]'));
    if (!items.length) return;

    items.forEach(function (item) {
      var btn = item.querySelector('[data-exp-faq-btn]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        // close all
        items.forEach(function (other) {
          other.classList.remove('is-open');
          var ob = other.querySelector('[data-exp-faq-btn]');
          if (ob) ob.setAttribute('aria-expanded', 'false');
        });
        // toggle this one (open if it was closed)
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
